import useCreateReducer from '../use-create-reducer';

import { RESIZE, SCROLL } from './constants';

const init = ({ innerHeight = 0, innerWidth = 0, scrollLeft = 0, scrollTop = 0 }) => ({
  innerHeight,
  innerWidth,
  scrollLeft,
  scrollTop,
});

const actionMap = {
  [RESIZE]: (state, { payload: { innerHeight = 0, innerWidth = 0 } }) => ({
    ...state,
    innerHeight,
    innerWidth,
  }),

  [SCROLL]: (state, { payload: { scrollLeft = 0, scrollTop = 0 } }) => ({
    ...state,
    scrollLeft,
    scrollTop,
  }),
};

const useWindowBoundingBoxReducer = () => useCreateReducer(actionMap, global.window, init);

export default useWindowBoundingBoxReducer;
